import React, { useContext } from 'react';

const ValidationContext = React.createContext();
export const useValidation = () => useContext(ValidationContext);

export default ValidationContext;
